import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect, useState } from 'react'
import { Analytics } from '@vercel/analytics/react';
import './App.css'
import Nav from './Nav.js'
import Publi from './Publi.js';
import Filtros from './Filtros.js';
import FestasShows from './FestasShows.js';
import Infantil from './Infantil.js';
import StandUp from './StandUp.js';
import Teatro from './Teatro.js';
import InfoLocal from './InfoLocal.js';
import localizarCalcularOrganizar from './LocalizarCalcularOrganizar.js';

function App(props){
  const [carregando, setCarregando] = useState(true)
  const [gratis, setGratis] = useState(false)
  const [selectValor, setSelectValor] = useState(0)
  const [selectData, setSelectData] = useState(new Date().toLocaleString('pt-BR').split(',')[0])
  const [eventos, setEventos] = useState([])
  const filtroValor = (lista) => selectValor ? lista.filter(elemento => parseInt(elemento.valor) <= selectValor) : lista
  const filtroData = (lista) => selectData ? lista.filter(elemento => elemento.data.toString() == selectData) : lista
  const datas = []  

  useEffect(() => {
    const carregarEventos = async () => {
      const resultados = await localizarCalcularOrganizar(props.eventos, setCarregando)
      setEventos(resultados)
    }
    carregarEventos()
  }, [props.eventos])

  eventos.map((item) => {
    if(datas.filter(elemento => elemento == item.data)[0] == undefined){datas.push(item.data)}
  })

  if(carregando){
    return(
      <div className="flex flex-col items-center justify-center w-screen h-screen bg-purple-950">
        <div className="w-16 h-16 border-4 border-purple-50 border-t-transparent rounded-full animate-spin"></div>
        <h1 className="mt-6 text-2xl md:text-3xl font-bold text-purple-50 animate-pulse tracking-wide">
          Bom Rolê
        </h1>
      </div>
    )
  }else{
    return(
      <Router>
        <div id='conteudo' className='flex flex-col items-center bg-purple-950 text-purple-50 font-mono h-screen overflow-y-auto'>
          <Routes>
              <Route exact path='/' element={
                <div className='flex flex-col items-center'>
                  <Nav />
                  <Publi />
                  <Filtros 
                    datas={datas}
                    selectData={selectData}
                    setSelectData={setSelectData}
                    gratis={gratis} setGratis={setGratis}
                    setSelectValor={setSelectValor}
                  />
                  <FestasShows selectData={selectData} selectValor={selectValor} locais={props.locais} eventosFiltrado={filtroValor(filtroData(eventos.filter(elememento => elememento.categoria == 'Festas e Shows')))} />
                </div>
              } />

              <Route exact path='/infantil' element={
                <div className='flex flex-col items-center'>
                  <Nav />
                  <Publi />
                  <Filtros 
                    datas={datas}
                    selectData={selectData}
                    setSelectData={setSelectData}
                    gratis={gratis} setGratis={setGratis}
                    setSelectValor={setSelectValor}
                  />
                  <Infantil selectData={selectData} selectValor={selectValor} locais={props.locais} eventosFiltrado={filtroValor(filtroData(eventos.filter(elememento => elememento.categoria == 'Infantil')))} />
                </div>
              } />

              <Route exact path='/standup' element={
                <div className='flex flex-col items-center'>
                  <Nav />
                  <Publi />
                  <Filtros 
                    datas={datas}
                    selectData={selectData}
                    setSelectData={setSelectData}
                    gratis={gratis} setGratis={setGratis}
                    setSelectValor={setSelectValor}
                  />
                  <StandUp selectData={selectData} selectValor={selectValor} locais={props.locais} eventosFiltrado={filtroValor(filtroData(eventos.filter(elememento => elememento.categoria == 'Stand Up')))} />
                </div>
              } />

              <Route exact path='/teatro' element={
                <div className='flex flex-col items-center'>
                  <Nav />
                  <Publi />
                  <Filtros 
                    datas={datas}
                    selectData={selectData}
                    setSelectData={setSelectData}
                    gratis={gratis} setGratis={setGratis}
                    setSelectValor={setSelectValor}
                  />
                  <Teatro selectData={selectData} selectValor={selectValor} locais={props.locais} eventosFiltrado={filtroValor(filtroData(eventos.filter(elememento => elememento.categoria == 'Teatro')))} />
                </div>
              } />

              <Route exact path='/infolocal' element={
                <InfoLocal locais={props.locais} eventos={eventos} />
              } />

              <Route exact path='/config' element={
                <div className='w-screen h-screen flex flex-col items-center gap-10 pt-32'>
                  <h1 className='text-2xl font-bold'>Configurações</h1>
                  <div className=' w-full flex justify-around'>
                    <div className='flex flex-col items-center'>
                      <h2 className='text-xl font-semibold'>Atualizar</h2>
                      <div className='flex flex-col gap-4 p-4'>
                        <a href='http://localhost:5000/rotasEvento/atualizar360' className='border rounded-xl bg-blue-200 hover:bg-blue-500 text-center'>Ticket360</a>
                        <a href='http://localhost:5000/rotasEvento/atualizarsympla' className='border rounded-xl bg-blue-200 hover:bg-blue-500 text-center'>Sympla</a>
                        <a href='http://localhost:5000/rotasEvento/shotgun' className='border rounded-xl bg-blue-200 hover:bg-blue-500 text-center'>shotgun</a>
                        <a href='http://localhost:5000/rotasEvento/atualizarSampaIngressos' className='border rounded-xl bg-blue-200 hover:bg-blue-500 px-2 text-center'>Sampa Ingressos</a>
                      </div>
                    </div>
                    <div className='flex flex-col items-center'>
                      <h1 className='text-xl font-semibold'>Limpar Roles antigos</h1>
                      <a href='http://localhost:5000/rotasEvento/limparroles' className='border rounded-xl bg-blue-200 hover:bg-blue-500 px-2 my-4 text-center'>Limpar</a>
                    </div>
                  </div>
                </div>
              } />
          </Routes>
          <Analytics />
        </div>
      </Router>
    )
  }
}

export default App;
